module.exports = __webpack_public_path__ + "static/media/main5.d7118c7a.jpg";